import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ExportService implements OnDestroy {

  private exportcounter:number = 1;
  public exportType:Subject<any>  = new Subject();
  public exportToExcelData:Subject<any> = new Subject();
  public blueBalloonLogsGridDataExportToExcelData:Subject<any> = new Subject();
  public blueBalloonLogsPinsListExportToExcelData:Subject<any> = new Subject;
  public exportToExcelDataCall:Subject<any> = new Subject();

  public callExportToExcelData() {
    let counter: number = this.exportcounter++;
    this.exportToExcelDataCall.next({callFunction : "export-to-excel", counter: counter});
    return counter;
  }

  public callBlueBalloonLogsGridDataExportToExcelData() {
    let counter: number = this.exportcounter++;
    this.exportToExcelDataCall.next({callFunction : "blue-balloon-logs-grid-export-to-excel", counter: counter});
    return counter;
  }

  public callBalloonLogsPinsListExportToExcelData(dataVal:any) {
    let counter: number = this.exportcounter++;
    this.exportToExcelDataCall.next({callFunction : "blue-balloon-logs-pins-export-to-excel", pinsData:dataVal, counter: counter});
    return counter;
  }  

  ngOnDestroy() {
    this.exportType.unsubscribe();
    this.exportToExcelData.unsubscribe();
    this.blueBalloonLogsGridDataExportToExcelData.unsubscribe();
    this.blueBalloonLogsPinsListExportToExcelData.unsubscribe();
    this.exportToExcelDataCall.unsubscribe();
  }
}
